import "bootstrap/dist/css/bootstrap.min.css";
import "./style/root.css";

import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import LayOut from "./pages/Layout";
import WhiskiesList from "./components/WhiskiesList";
import Login from "./components/Login";
import UploadExcel from "./components/UploadExcel";
import { ToastContextProvider } from "./contexts/ToastContext";
import React from "react";

const NotFound = () => (
  <div style={{ color: "cornsilk" }}>404 You're lost ;(</div>
);

function App() {
  const user = useSelector((state) => state.user.user);

  return (
    <ToastContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LayOut user={user} />}>
            <Route index element={<WhiskiesList />} />
            <Route path="login" element={<Login />} />
            <Route
              path="/upload"
              element={user ? <UploadExcel /> : <NotFound />}
            />
          </Route>
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ToastContextProvider>
  );
}

export default App;
